//#region src/properties/resolveStayCardMetaLine.ts
var e = (e) => e.checkIn && e.checkOut ? {
	kind: "dates",
	checkIn: e.checkIn,
	checkOut: e.checkOut
} : { kind: "facts" };
//#endregion
export { e as resolveStayCardMetaLine };
